import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

// Generalised from connect-v2's ComingSoon card.
export function EmptyState({
	icon: Icon,
	title,
	description,
	action,
	className,
}: {
	icon?: LucideIcon;
	title: string;
	description?: string;
	action?: ReactNode;
	className?: string;
}) {
	return (
		<div
			className={cn(
				"bg-card flex flex-col items-center justify-center rounded-xl border border-dashed p-8 text-center sm:p-12",
				className,
			)}
		>
			{Icon && (
				<div className="bg-primary/10 text-primary mb-4 flex size-14 items-center justify-center rounded-full">
					<Icon className="size-6" />
				</div>
			)}
			<h2 className="text-foreground text-base font-semibold">{title}</h2>
			{description && <p className="text-muted-foreground mt-2 max-w-sm text-sm">{description}</p>}
			{action && <div className="mt-4">{action}</div>}
		</div>
	);
}
